<template>
  <div class="top-nav">
    <div class="top-bars">
      <div class="green-top"></div>
      <div class="blue-top"></div>
      <div class="yellow-top"></div>
      <div class="red-top"></div>
    </div>
    <div class="esg-bar">
      <div class="esg-logo">
        <a href="https://ekitistate.gov.ng/" target="_blank"><img src="../assets/esg-logo.jpg" height="50px"/></a>
      </div>
      <div class="social-media">
        <a href="https://twitter.com/InvestEkiti" target="_blank"><i class="fab fa-twitter"></i></a>
        <a href="https://instagram.com/investekiti?igshid=ZDdkNTZiNTM=" target="_blank"><i class="fab fa-instagram"></i></a>
        <a href="https://www.linkedin.com/company/ekiti-state-development-and-investment-promotion-agency-ekdipa/" target="_blank"><i class="fab fa-linkedin"></i></a>
        <a href="https://ppp.ekdipa.com.ng/web" class="ppp-disclosure">PPP Disclosure Portal</a>
        <!-- <a href="#"><i class="fas fa-search"></i></a> -->
      </div>
    </div>
    <div class="sub-top-nav">
      <header>
        <div class="menu-icon" @click="toggleMenu" v-if="!open"><i class="fas fa-bars fa-2x"></i></div>
        <div class="logo">
          <router-link to="/"><img src="../assets/ekdipa-logo.png"/></router-link>
        </div>
        <nav>
          <div class="close-icon" @click="toggleMenu()" v-if="open"><i class="fas fa-times fa-2x"></i></div>
          <div class="menu-block">
            <div v-bind:class="[open ? 'open' : '', 'links', 'animated', animateClass]">
              <div class="spacer">&nbsp;</div>
              <router-link to="/#" @mouseover.native="loadSubMenu()">Home</router-link>
              <span v-for="menu in menuItems" :key="menu.nid" :class="[menu.parent ? 'child' : '', menu.children && menu.children.length > 0 ? 'parent' : '']">
                <div class="spacer">&nbsp;</div>
                <router-link :to="'/' + menu.vuepath" @mouseover.native="loadSubMenu(menu)"
                  >{{ menu.name }}<span>&nbsp;&nbsp;<i class="fas fa-plus" v-if="menu.children && menu.children.length > 0"></i></span
                ></router-link>
              </span>
            </div>
          </div>
        </nav>
      </header>
    </div>

    <div class="sub-menu animated fadeIn" v-show="subMenuOpen" @mouseleave="subMenuOpen = false">
      <div class="sub-menu-divs">
        <!-- <div class="div-1">&nbsp;</div> -->
        <div class="div-6">
          <h3>
            <span v-if="subHeader">{{ subHeader }}</span>
          </h3>
          <p>
            <span v-if="subDetails">{{ subDetails }}</span>
          </p>
          <router-link :to="mainSubLink" tag="button" class="btn btn-secondary" v-if="subHeader">Find out More</router-link>
        </div>
        <div class="div-5">
          <ul>
            <li v-for="link in subLinks" :key="link.nid">
              <a :href="'/' + link.vuepath">{{ link.name }} </a>
              <div class="bs-icon"><i class="fas fa-angle-right"></i></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      open: false,
      subMenuOpen: false,
      animateClass: "",
      menuItems: [],
      baseMenu: [],
      subLinks: [],
      subHeader: null,
      subDetails: null,
      mainSubLink: "/",
    }
  },
  methods: {
    ...mapActions(["setNavigation"]),
    toggleMenu() {
      if (this.open) {
        this.animateClass = ""
      } else {
        this.animateClass = ""
      }

      this.open = !this.open
    },
    showSubMenu() {
      this.subMenuOpen = true
    },
    loadSubMenu(menuObj) {
      this.subMenuOpen = false
      if (menuObj && menuObj.children && menuObj.children.length > 0) {
        this.subHeader = menuObj.header
        this.subDetails = menuObj.overview
        this.subLinks = this.menuItems.filter(function(item) {
          return menuObj.children.includes(item.nid)
        })
        this.mainSubLink = "/" + this.subLinks[0].vuepath
        this.showSubMenu()
      } else {
        return false
      }
    },
    getMenu() {
      if (this.menuItems.length == 0) this.menuItems = this.navigation
      if (this.menuItems && this.menuItems.length) {
        this.baseMenu = this.menuItems.filter(function(item) {
          return !item.parent
        })
      }
    },

    async getNav() {
      const { data } = await ContentRepository.getMenu()

      this.menuItems = data

      // var navExpire = this.$moment().add(1, 'days')

      // if (!this.$session.exists()){
      //   this.$session.start()
      // }
      // this.$session.set('navigation', data)
      // this.$session.set('navigation_exp', navExpire)
      // console.log('in here local getnav')

      this.getMenu()
      // this.setNavigation({data: data})
    },
  },
  computed: {
    ...mapGetters({
      navigation: "getSiteNav",
    }),
  },
  created() {
    // console.log('in here created')
    // const navigation = this.$session.get('navigation')
    // const navigation_exp = this.$session.get('navigation_exp')

    // if (!navigation || this.$moment().isAfter(navigation_exp) || !navigation_exp){
    if (!this.navigation || this.navigation.length == 0) {
      this.getNav()
    } else {
      this.getMenu()
    }
  },
  watch: {
    $route() {
      this.open = false
    },
  },
}
</script>

<style>
.top-bars {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.red-top {
  border-top: 5px solid #cc0000;
}

.yellow-top {
  border-top: 5px solid #ffcc33;
}

.green-top {
  border-top: 5px solid #339900;
}

.blue-top {
  border-top: 5px solid #08b7de;
}

.esg-bar {
  background: #fff;
  border-bottom: 1px solid #e2e1e0;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.esg-bar .esg-logo {
  text-align: left;
  padding-left: 10%;
}

.esg-bar .social-media {
  text-align: right;
  padding-right: 10%;
}

.esg-bar a {
  margin: 10px;
  display: inline-block;
}

.logo {
  padding-left: 5%;
  text-align: left;
  float: left;
}

.menu-block {
  float: right;
  margin-right: 5%;
  text-align: right;
}

.menu-block .child {
  display: none;
}

.menu-block .open .parent {
  display: none;
}

.menu-block .open .child {
  display: inline;
}

.ppp-disclosure {
  background: #339900;
  padding: 5px 10px;
  color: #fff;
  border-radius: 5px;
  font-weight: bold;
}

.ppp-disclosure:hover {
  color: #fff;
  background: #000;
  text-decoration: none;
}
</style>
